import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import ourStaff from '../../../helpers/ourStaff';

import MatchesDashboard from './Dashboard';
import MatchRead from './Read';
import NoMatch from '../../NoMatch';

const Matches = props => (
    <div id="matches">
        <Switch>
            <Route exact path='/matches' component={MatchesDashboard} />
            <Route path='/matches/read/:id' component={MatchRead} />
            <Route component={NoMatch} />
        </Switch>
    </div>
);

Matches.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(
    state => ({ user: ourStaff[state.authentication.userId] || state.authentication.user || {} })
)(Matches);



// WEBPACK FOOTER //
// ./src/pages/OnSite/Matches/index.js